import React, {Component} from 'react'
import './mediaFusionIndex.css'
import QuantityCard from "../components/QuantityCard";
import HotTopicList from "../components/HotTopicList";
import MyDeskGraphCard from "../components/MyDeskGraphCard";
import {Col, Row} from "antd";
import {
    getTotalPostAmount,getNumber
} from "../actions";

import {connect} from "react-redux";

/**
 * 融媒体管理平台，我的桌面
 */
class MediaFusionIndex extends Component {
    constructor(props) {
        super(props)
        this.state = {
            allPostArticleCount: 0,
            allfansCount: 0,
            allaccessCount: 0,
            myPostArticleCount: 0,
        }
    }

    isLoad = false;/*判断是否已经加载了数据*/
    updateTotalPostAmount(totalData) {

        this.isLoad=true;
        this.setState({
            // allPostArticleCount: totalData.articleCount,
            // allfansCount: totalData.fansCount,
            allaccessCount:totalData.total,
            // myPostArticleCount:totalData.myArticleCount
        });
    }

    //数字转成三位逗号相隔的字符串；
     format_number(nStr ){
        nStr += '';
        let x = nStr.split('.');
       let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    }
    update (data){
        this.setState({
             allPostArticleCount: data.total,
             allfansCount: data.rmUserCount,
             myPostArticleCount:data.readCount
        });

    }

    render() {
        //获取总发文量
        if(this.props.currentUser&&!this.isLoad){
            getTotalPostAmount(this.updateTotalPostAmount.bind(this));
            getNumber(this.update.bind(this));
        }

        return <div className='mydeskContainer'>
            <div className='mydeskTop'>
                <Row >
                    <Col xs={24} md={12} xxl={6}>
                        <QuantityCard cardTitle='总发文量' image={'images/top01.png'}
                                      number={this.state.allPostArticleCount}></QuantityCard>
                    </Col>
                    <Col xs={24} md={12} xxl={6}><QuantityCard image={'images/top02.png'} cardTitle='总粉丝量'
                                                               number={this.state.allfansCount}></QuantityCard></Col>
                    <Col xs={24} md={12} xxl={6}><QuantityCard image={'images/top03.png'} cardTitle='用户访问总量'
                                                               number={this.state.allaccessCount}></QuantityCard></Col>
                    <Col xs={24} md={12} xxl={6}><QuantityCard image={'images/top04.png'} cardTitle='用户阅读量'
                                                               number={this.state.myPostArticleCount}></QuantityCard></Col>
                </Row>
            </div>
            <div className='mydeskMiddle'>
                <Row>
                    <Col xs={24} md={24} xxl={16}>
                        <div className='mydeskLeft'>
                            <MyDeskGraphCard></MyDeskGraphCard>
                        </div>
                    </Col>
                    <Col xs={24} md={24} xxl={8}>
                        <div className='mydeskRight'>
                            <HotTopicList></HotTopicList>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    }
}

function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser
    }
}

export default connect(mapStateToProps)(MediaFusionIndex);